import _pickBy from "lodash/pickBy";

export default function filterQueryParams (obj) {
  return _pickBy(obj, o => o !== null && o !== undefined && o?.length !== 0);
}
